export default function useTense(past) {
  const event_has_past = past;
  const tense = (present, past) => {
    return event_has_past ? past : present;
  };

  return {tense};
}
